import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table} from 'antd'
import history from '../../../routes/history'
import * as AppUrl from '../../../constants/appUrl'
import {withTranslation} from 'react-i18next'

const {Column} = Table

@inject('messageManagementStore')
@observer
class SearchResult extends Component {
  handlePageChange = (page, pageSize) => {
    const {messageManagementStore} = this.props
    messageManagementStore.onChangePageNumAction(page, pageSize || 10)
  }

  showDetails = (record, status) => {
    const {messageManagementStore} = this.props
    const {searchItem} = messageManagementStore
    const searchParams = {
      ...searchItem,
      status,
      unionKey: record.id,
      record,
      tabsValue: messageManagementStore.tabsValue
    }
    console.log('searchItem', searchItem)
    history.push(AppUrl.MESSAGEDETAILS, {searchParams})
  }

  handlePageChangeAntd = (pageNo, pageSize) => {
    const {messageManagementStore} = this.props
    messageManagementStore.onChangePageNo(pageNo, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {messageManagementStore, t} = this.props
    const {pageNo, pageSize, itemCount, messageOverviewList} = messageManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={messageOverviewList.length ? messageOverviewList : null} pagination={pagination}
               rowClassName={this.getRowClassName} rowKey="id" scroll={{x: 'max-content', scrollToFirstRowOnChange: true}}>
          <Column fixed="left" align="center" title={t(`messageManagement.error`)} dataIndex="errorCount"
                  render={(text, record, index) => text === 0 ? <span style={{color: '#ff3b30'}}>{text}</span> :
                    <span onClick={() => this.showDetails(record, 'ERROR')}
                          style={{color: '#ff3b30', textDecoration: 'underline', cursor: 'pointer'}}>{text}</span>}/>
          <Column fixed="left" align="center" title={t(`messageManagement.scheduled`)} dataIndex="scheduledCount"
                  render={(text, record, index) => text === 0 ? <span style={{color: '#00b7f4'}}>{text}</span> :
                    <span onClick={() => this.showDetails(record, 'SCHEDULED')}
                          style={{color: '#00b7f4', textDecoration: 'underline', cursor: 'pointer'}}>{text}</span>}/>
          <Column fixed="left" align="center" title={t(`messageManagement.successful`)} dataIndex="successCount"
                  render={(text, record, index) => text === 0 ? <span style={{color: '#00b578'}}>{text}</span> :
                    <span onClick={() => this.showDetails(record, 'SUCCESSFUL')}
                          style={{color: '#00b578', textDecoration: 'underline', cursor: 'pointer'}}>{text}</span>}/>
          <Column fixed="left" align="center" title={t(`messageManagement.running`)} dataIndex="runningCount"
                  render={(text, record, index) => text === 0 ? <span style={{color: '#c19030'}}>{text}</span> :
                    <span onClick={() => this.showDetails(record, 'RUNNING')}
                          style={{color: '#c19030', textDecoration: 'underline', cursor: 'pointer'}}>{text}</span>}/>
          <Column title={t(`messageManagement.inboundCustomer`)} dataIndex="inboundCustomerStr" key="inboundCustomerStr"/>
          <Column title={t(`messageManagement.inboundName`)} dataIndex="inboundName" key="inboundName"/>
          <Column title={t(`messageManagement.outboundCustomer`)} dataIndex="outboundCustomerStr" key="outboundCustomerStr"/>
          <Column title={t(`messageManagement.outboundName`)} dataIndex="outboundName" key="outboundName"/>
          <Column title={t(`messageManagement.direction`)} dataIndex="direction"/>
        </Table>
        {/*{tabsValue==='APIInformationSearch'?null:<Pagination*/}
        {/*  current={pageNo}*/}
        {/*  pageSize={pageSize}*/}
        {/*  onChange={this.handlePageChangeAntd}*/}
        {/*  total={itemCount}*/}
        {/*  showSizeChanger*/}
        {/*  showQuickJumper*/}
        {/*  showTotal={total => `共${total}条数据`}*/}
        {/*  pageSizeOptions={['10', '20', '50', '100']}*/}
        {/*  style={{marginTop: 16, paddingBottom:16, textAlign: 'right'}}*/}
        {/*/>}*/}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
